const langDefault = 'en-US';
const getLang = (locale = langDefault) => {
    if (locale) {
        return locale;
    }
    else {
        return langDefault;
    }
};
const getFormatLang = (lang = getLang()) => {
    const formatLangMapper = {
        'es-': 'de-DE',
        'pr-': 'fr-FR',
    };
    Object.keys(formatLangMapper).forEach((key) => {
        if (lang.includes(key, 0))
            lang = formatLangMapper[key];
    });
    return lang;
};

export { getFormatLang, getLang, langDefault };
//# sourceMappingURL=langs.utils.js.map
